angular.module('bmsApp.sm.job')
	.factory('SMJobSvc', function ($q,
								   $modal,
								   $rootScope,
								   CRUDSvc,
								   SMCleaningServiceSvc) {

		var self = {
			index: function (params) {
				return CRUDSvc.get('api/sm/job/index', params);
			},
			save: function (job) {
				return CRUDSvc.post('api/sm/job/save', job);
			},
			close: function (job) {
				return CRUDSvc.post('api/sm/job/close', job);
			},
			read: function (id, params) {
				return CRUDSvc.get('api/sm/job/read/' + id, params);
			},
			options: function() {
				return CRUDSvc.get('api/sm/job/options');
			},
			showCopyQuoteModal: function (job) {
				var modalInstance = $modal.open({
					animation: true,
					templateUrl: 'ng/sm/job/templates/CopyJobModal.html',
					controller: 'SMCopyJobModalCtrl',
					size: 'md',
					scope: $rootScope,
					backdrop: 'static', // disable click-outside closing modal
					resolve: {
						job: function () {
							return angular.copy(job);
						}
					}
				});

				return modalInstance.result;
			},
			copy: function (params) {
				return CRUDSvc.post('api/sm/job/copy', params);
			},
			delete: function(params) {
				return CRUDSvc.post('api/sm/job/delete', params);
			},
			orderConfirmationEmail: function(params) {
				return CRUDSvc.get('api/sm/job/orderConfirmationEmail', params);
			},
			quotesByCustomerOrCustomerEnquiry: function (customerId, params) {
				var newParams = angular.extend({}, params, {
					filter: {
						converted: false,
						customerOrCustomerEnquiry: customerId
					}
				});
				return CRUDSvc.get('api/sm/job/index', newParams);
			},
			jobsByCustomer: function (customerId, params) {
				var newParams = angular.extend({}, params, {
					filter: {
						converted: true,
						customer: customerId
					}
				});
				return CRUDSvc.get('api/sm/job/index', newParams);
			},
			customerInvoiceOptions: function(customerId) {
				return CRUDSvc.get('api/sm/job/customer-invoice-options/' + customerId);
			},
			cancelReason: {
				options: function (params) {
					return CRUDSvc.get('api/sm/job-cancel-reason/options', params);
				}
			},
			preinvoice: function(params) {
				return CRUDSvc.post('api/sm/job/preinvoice', params);
			},
			cancel: {
				showModal: function (job) {
					var modalInstance = $modal.open({
						animation: true,
						templateUrl: 'ng/sm/job/templates/CancelJobModal.html',
						controller: 'SMCancelJobModalCtrl',
						size: 'md',
						scope: $rootScope,
						backdrop: 'static', // disable click-outside closing modal
						resolve: {
							job: function () {
								return angular.copy(job);
							}
						}
					});

					return modalInstance.result;
				},
				save: function(params) {
					return CRUDSvc.post('api/sm/job/cancelJob', params);
				},
				reinstate: function(params) {
					return CRUDSvc.post('api/sm/job/reinstateJob', params);
				}
			},
			unconfirmedTechnicianJobNotifications: function () {
				return CRUDSvc.get('api/sm/job/unconfirmed-technician-notifications');
			},
			confirmTechnicianJobNotification: function (jobId) {
				return CRUDSvc.post('api/sm/job/confirm-technician-job-notification', {
					job: {
						id: jobId
					}
				});
			},
			discountType: {
				options: function (params) {
					return CRUDSvc.get('api/sm/job-discount-type/options', params);
				}
			},
			calcValue: function (job) {
				if (angular.isObject(job)) {
					job.net = job.vat = job.gross = 0;
					var csCallback = function (cleaningService) {
						if (!cleaningService.delete) {
							job.net += SMCleaningServiceSvc.calcDiscountedNet(cleaningService);
							job.vat += SMCleaningServiceSvc.calcDiscountedVat(cleaningService);
							job.gross += SMCleaningServiceSvc.calcDiscountedGross(cleaningService);
						}
					};
					if (angular.isArray(job.scheduled_cleaning_services)) {
						angular.forEach(job.scheduled_cleaning_services, csCallback);
					}
					if (angular.isArray(job.additional_cleaning_services)) {
						angular.forEach(job.additional_cleaning_services, csCallback);
					}

					// TODO: calculate discounted values
				}
			},
			checkVisitAvailability: function (visit, employee, job) {
				return CRUDSvc.get('api/sm/schedule/check-visit-availability', {
					visit: {
						id: visit.id,
						visit_date: visit.visit_date,
						duration_in_mins: visit.duration_in_mins,
					},
					employee: {
						id: employee ? employee.id : null,
					},
					job: {
						id: job ? job.id : null,
					},
				});
			},
			export: function(params) {
				var newParams = angular.extend({}, params, {
					'format': 'csv'
				});
				var query = $.param(newParams);
				window.open('api/sm/job/index' + '?' + query);
			},
		};
		return self;

	});
